import React from 'react';


export class Checkbox extends React.Component {
    constructor(props) {
        super(props);
        this.id = (Math.random() + 1).toString(36).substring(2);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            value: '',
            label: '',
            checked: false,
            onChange: (event) => {},
            ...this.props
        };
    }

    render() {
        return (
            <span>
                <input
                    type="checkbox"
                    id={this.id}
                    className="imd-form-checkbox"
                    checked={this.state.checked}
                    onChange={(event) => this.state.onChange(event)}
                />

                <label htmlFor={this.id} className="imd-text-main">
                    <span className="imd-border-color-main"></span>
                    {this.state.label}
                </label>
            </span>
        );
    }
}
